import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { AlertController } from '@ionic/angular';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { InactivityType } from '../enums/inactivity-type';
import { CourseService } from './course.service';
import { Capacitor } from '@capacitor/core';
@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  env = environment;

  activeSeconds: number;
  lastTimestamp: number;
  running = false;
  instanceId: number;
  nodeId: number;
  inactivityDuration: number;
  inactivityTimer: any;

  timeRemaining: moment.Duration;
  minutesRemaining: number;
  secondsRemaining: number;
  secondsString: string;
  countdownTimer: any;
  inactivityType: InactivityType;
  courseService: CourseService;
  alert: HTMLIonAlertElement;

  constructor(
    private http: HttpClient,
    private alertController: AlertController,
    private loginService: LoginService,
    private router: Router,
  ) {

  }

  start(instanceId, inactivityDuration: number) {
    this.instanceId = instanceId;
    this.lastTimestamp = moment.now();
    this.activeSeconds = 0;
    this.running = true;
    this.inactivityDuration = inactivityDuration;
  }

  report() {
    let secondsSince = (moment.now() - this.lastTimestamp) / 1000;
    this.activeSeconds += secondsSince;
    this.lastTimestamp = moment.now();
    let Seconds = Math.floor(this.activeSeconds);
    if (Seconds < 60) {
      return;
    }
    this.start(this.instanceId, this.inactivityDuration);
    console.log('Posting activity...');
    this.http.post(`${environment.baseApiUrl}activity/${this.instanceId}`, null, { withCredentials: true }).subscribe(result => {
    });
  }

  recordActivity() {
    if (!this.running) {
      return;
    }
    this.report();
    if (this.inactivityDuration) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.running = false;
        this.inactivityAlert();
      }, ((this.inactivityDuration - 2) * 60 * 1000)); //show 2 minute warning before auto log out
    }
  }

  setCourseService(courseService: CourseService) {
    this.courseService = courseService;
  }

  setMessage() {
    return "You have been inactive and will be logged out in " + this.minutesRemaining + ":" + this.secondsString + " minutes.";
  }

  async inactivityAlert() {
    this.startTimer();
    this.alert = await this.alertController.create({
      header: 'Still there?',
      message: this.setMessage(),
      buttons: [
        {
          text: 'Exit Course',
          handler: () => {
            console.log('Exit course clicked');
            this.inactivityType = InactivityType.ExitCourse;
            this.ExitCourseEvent(true);
          }
        },
        {
          text: 'Continue',
          role: 'cancel',
          handler: () => {
            console.log('Continue course clicked');
            this.continue();
          }
        }
      ],
    });
    await this.alert.present();

  }

  async logout() {
    clearInterval(this.countdownTimer);
    console.log("Logout Current NodeId: " + this.courseService.nav.CurrentNode.Id);
    if (this.inactivityType === InactivityType.Logout) {
      this.recordLogoutEvent(this.courseService.nav.CurrentNode.Id);
    }
    else {
      this.recordAutoLogoutEvent(this.courseService.nav.CurrentNode.Id);
    }
    this.loginService.logout();
    this.router.navigateByUrl('/', { replaceUrl: true });
  }

  startTimer() {
    this.timeRemaining = moment.duration(2, 'minutes');

    this.minutesRemaining = this.timeRemaining.minutes();
    this.secondsRemaining = this.timeRemaining.seconds();
    this.secondsString = this.secondsRemaining.toString();
    this.secondsString = this.secondsString.padStart(2, "0");

    this.updateTimer();
  }

  updateTimer() {
    this.countdownTimer = setInterval(() => {
      this.timeRemaining = this.timeRemaining.subtract(1, "second");

      this.minutesRemaining = this.timeRemaining.minutes();
      this.secondsRemaining = this.timeRemaining.seconds();
      this.secondsString = this.secondsRemaining.toString();
      this.secondsString = this.secondsString.padStart(2, "0");

      if (this.alert) {
        this.alert.message = this.setMessage();
      }
      if (this.minutesRemaining === 0 && this.secondsRemaining === 0) {
        this.inactivityType = InactivityType.AutoExitCourse;
        if (this.alert) {
          this.alert.dismiss();
        }
        this.ExitCourseEvent(true);
      }
    }, 1000);
  }

  continue() {
    clearInterval(this.countdownTimer);
    this.running = true;
    this.recordActivity();
  }

  ExitCourseEvent(routeHome: boolean) {
    this.running = false;
    clearInterval(this.countdownTimer);
    clearTimeout(this.inactivityTimer);
    if (this.instanceId && this.nodeId) {
      this.http.post(`${environment.rootDomainUrl}api/ExitCourseEvent?instanceId=${this.instanceId}&nodeId=${this.nodeId}`, null, { withCredentials: true }).subscribe(result => {
        if (routeHome) {
          if (Capacitor.isNativePlatform()) {
            this.router.navigateByUrl('/home', { replaceUrl: true });
          }
          else {
            window.close();
          }
        }
      });
    } else {
      if (Capacitor.isNativePlatform()) {
        this.router.navigateByUrl('/home', { replaceUrl: true });
      }
      else {
        window.close();
      }
    }
  }

  recordAutoLogoutEvent(nodeId: number) {
    this.http.get(`${environment.rootDomainUrl}AutomaticLogoutEvent?courseInstanceId=${this.instanceId}&nodeId=${nodeId}`, { withCredentials: true }).subscribe(result => {
    });
  }

  recordLogoutEvent(nodeId: number) {
    this.http.get(`${environment.rootDomainUrl}LogoutEvent?courseInstanceId=${this.instanceId}&nodeId=${nodeId}`, { withCredentials: true }).subscribe(result => {
    });
  }
}
